import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { VolunteeringAreaService } from '../volunteering-area.service';
import { VolunteeringSpecialistsTab1Part } from './tabs/tab-1/volunteering-specialists-tab-1.part';
import { VolunteeringSpecialistsTab2Part } from './tabs/tab-2/volunteering-specialists-tab-2.part';
import { VolunteeringSpecialistsViewsPart } from './views/volunteering-specialists-views.part';
import { VolunteeringSpecialistsService } from './volunteering-specialists.service';

@Component({
	selector: 'volunteering-specialists-page',
	standalone: true,
	imports: [
		VolunteeringSpecialistsViewsPart,
		VolunteeringSpecialistsTab1Part,
		VolunteeringSpecialistsTab2Part,
		PageTab1Directive, PageTab2Directive, PageTab3Directive, TrimesterDroplistWidget,
		DroplistWidget, ToolbarWidget,
		PageTabsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-specialists.page.html',
})
export class VolunteeringSpecialistsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public areaService = inject(VolunteeringAreaService);
	public pageService = inject(VolunteeringSpecialistsService);
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}